import { Zone } from './user'

export const Currency = Object.freeze({
  CNY: 1,
  USD: 2,
})
export const StudentStatus = Object.freeze({
  Unverified: 1,
  Verified: 2,
  Refused: 3,
  Expired: 4,
})
export const CouponType = Object.freeze({
  Voucher: 0,
  GPUCoupon: 1,
  CPUCoupon: 2,
  GeneralCoupon: 3,
  CPUQingyunCoupon: 4,
  PictureMember: 5,
  GPUQingyunCoupon: 6,
  DesktopCoupon: 8,
})
export const EngineType = Object.freeze({
  Aspera: 1,
  Typhoon: 2,
  Rayvision: 3,
  TCP: 4,
  RaySync: 5,
})
export const InvoiceType = Object.freeze({
  VATGeneralInvoice: 0,
  VATInvoice: 1,
  ElectronicGeneralInvoice: 2,
})

export const VIP = Object.freeze({
  Ordinary: 49,
  Silver: 55,
  Gold: 56,
  Platinum: 57,
  Diamond: 58,
})

export const VIPNational = Object.freeze({
  Ordinary: 49,
  Gold: 56,
  Diamond: 58,
})

export const CompletedAnalyseStatus = Object.freeze({
  WaitingToSubmit: 0,
  AnalysisCompletedWithWarning: 5,
  AnalysisCompletedWithError: 10,
  AnalysisFailed: 15,
  SubmitRenderFailed: 30,
  SubmittedAutomatically: 35,
  Submitted: 40,
  GiveUp: 45,
  Timeout: 48,
})

export const AnalysisCompleteStatus = Object.freeze({
  WaitingToSubmit: 0,
  AnalysisCompletedWithWarning: 5,
  AnalysisCompletedWithError: 10,
})

export const CompletedAnalyseStatusCascader = Object.freeze({
  AnalysisComplete: {
    ...AnalysisCompleteStatus,
  },
  AnalysisFailed: 15,
  SubmitRenderFailed: 30,
  SubmittedAutomatically: 35,
  Submitted: 40,
  GiveUp: 45,
  Timeout: 48,
})
export const AnalysesingStatus = Object.freeze({
  Analyzing: 20,
  WaitingToAnalyze: 25,
})
export const Sky3EndStatus = Object.freeze({
  Succeeded: 25,
  Failed: 45,
  Stopped: 10,
  arrearStop: 20,
  timeout: 23,
  FailTotalBlock: 30,
})
export const Sky3EndTileStatus = Object.freeze({
  Stopped: 3,
  Succeeded: 4,
  Failed: 5,
})
export const Sky3RunningStatus = Object.freeze({
  emptyThreeWaitingSubmit: 60,
  emptyThreeWaiting: 0,
  emptyThreeing: 5,
})
export const Sky3RunningTileStatus = Object.freeze({
  emptyThreeTimeOut: 11,
  emptyThreeWaiting: 1,
  emptyThreeCalculating: 2,
})
export const RebuildRunStatus = Object.freeze({
  Rebuilding: 5,
  WaitingRebuild: 0,
  WaitingToSubmit: 60,
})
export const RebuildEndStatus = Object.freeze({
  rebuildEndSubmit: 25,
  rebuildFail: 45,
  rebuildStop: 10,
  timeout: 23,
})
export const PreHandleStatus = Object.freeze({
  Waiting: 0,
  Preprocessing: 8,
  Stopped: 10,
  Timeout: 23,
  Succeed: 25,
  Fail: 45,
})

export const CompletedTaskStatus = Object.freeze({
  Stopped: 10,
  Timeout: 23,
  Succeed: 25,
  CompletedWithStopedFrames: 70,
  CompletedWithFailedFrames: 30,
  GiveUp: 35,
  TestComlplete: 40,
  Fail: 45,
  SubmissionFailed: 65,
})

// 停止： 用户或管理员停止或欠费停止10、超时停止23
export const StopCate = Object.freeze({
  Stopped: 10,
  Timeout: 23,
})

// 完成： 无异常帧25、有停止帧70、有失败帧30
export const DoneCate = Object.freeze({
  Succeed: 25,
  CompletedWithStopedFrames: 70,
  CompletedWithFailedFrames: 30,
})

// 1用户停止 2管理员停止 3欠费停止
export const StopTypes = Object.freeze({
  userStop: 1,
  adminStop: 2,
  arrearStop: 3,
})

export const ProductEndTaskStatus = Object.freeze({
  Stopped: 10,
  Succeed: 25,
  Fail: 45,
  FailTotalBlock: 30,
  arrearStop: 20,
  timeout: 23,
})
export const PublishTaskStatus = Object.freeze({
  Complete: 0,
  Publishing: 20,
})
export const RenderingTaskStatus = Object.freeze({
  Waiting: 0,
  Rendering: 5,
  Submitting: 60,
})
export const ProductTaskStatus = Object.freeze({
  Waiting: 0,
  Producting: 5,
})
export const ProductRunningTileStatus = Object.freeze({
  Producting: 2,
  Waiting: 1,
  Stoped: 3,
  Succeed: 4,
  Failed: 5,
})
export const ProductEndTileStatus = Object.freeze({
  Stopped: 3,
  Succeed: 4,
  Fail: 5,
  TimeOut: 11,
})
export const rebuildTileStatus = Object.freeze({
  Producting: 2,
  Waiting: 1,
  Stoped: 3,
  Succeed: 4,
  Failed: 5,
  TimeOut: 11,
})
export const RechargeStatus = Object.freeze({
  Paying: 1,
  Success: 2,
  Cancel: 3,
  Failed: 4,
  Refund: 5,
  ToConfirm: 6,
  Confirmed: 7,
})
export const PayMethod = Object.freeze({
  Alipay: 1,
  Wechat: 2,
  Paypal: 3,
  CouponRecharge: 4,
  SubAccountTransferIn: 5,
  MasterAccountTransferIn: 6,
  TransferToSubAccount: 7,
  TransferToMasterAccount: 8,
  PresentedAtRegistration: 9,
  PresentedAtCompletingInformation: 10,
  InvoicePrecharge: 11,
  ChargeAfterInvoicing: 12,
  OfflineCharge: 13,
  CashRefund: 14,
  ReturnTheError: 15,
  Presentation: 16,
  OldPlatformTransferred: 17,
  BalanceAdjustment: 22,
  AlipayRechargeCPUQingyunCoupon: 30,
  WeChatRechargeCPUQingyunCoupon: 31,
  OfflineReloading: 37,
  WeChatAppletPayment: 38,
  RechargeAdjustment: 39,
  ConsumeAdjustment: 40,
  AlipayRechargeGPUQingyunCoupon: 41,
  WeChatRechargeGPUQingyunCoupon: 42,
  OfflineRechargeGPUQingyunCoupon: 43,
  SystemPresentRenderingMember: 50,
  WechatDesktop: 64,
  AlipayDesktop: 65,
})

export const getBusinessTypeByPayMethod = (payMethod) => {
  return [PayMethod.WechatDesktop, PayMethod.AlipayDesktop].includes(payMethod) ? 1 : 0
}

export const RechargeChannels = Object.freeze({
  web: 1,
  client: 2,
  miniProgram: 3,
})

export const GetWay = Object.freeze({
  CouponRecharge: 4,
  PresentedAtRegistration: 9,
  PresentedAtCompletingInformation: 10,
  MiniProgramGift: 25,
  ReChargeAfterInvoicing: 12,
  ErrorReturn: 15,
  Presentation: 16,
  OldPlatformTransferCoupon: 18,
  ActivityGift: 19,
  AgentCoupon: 20,
  WeChatGift: 21,
  TestGift: 23,
  InvitationToRecharge: 24,
  AlipayRechargeCPUQingyunCoupon: 30,
  WeChatRechargeCPUQingyunCoupon: 31,
  CouponErrorReturn: 32,
  SubAccountTransfer: 33,
  VoucherMainAccountTransfer: 34,
  TransferToSubAccount: 35,
  TransferToMainAccount: 36,
  OfflineReloading: 37,
  WeChatAppletPayment: 38,
  RechargeAdjustment: 39,
  ConsumeAdjustment: 40,
  AlipayRechargeGPUQingyunCoupon: 41,
  WeChatRechargeGPUQingyunCoupon: 42,
  OfflineRechargeGPUQingyunCoupon: 43,
  SystemPresentRenderingMember: 50,
  ActivityPresentation: 53,
  WeChatRechargeCloudProductionCoin: 64,
  AlipayRechargeCloudProductionCoin: 65,
})
export const MemberType = Object.freeze({
  Monthly: 1,
  Year: 2,
  Quarterly: 3,
  Semiannual: 6,
  Present: 0,
})
export const FileType = Object.freeze({
  Picture: 1,
  Text: 2,
  Video: 3,
  Audio: 4,
  Other: 5,
})
export const AuditStatus = Object.freeze({
  NotSubmitted: 0,
  UnderReview: 1,
  Approved: 3,
  Failed: 4,
})
export const RegisterBuildStatus = Object.freeze({
  NotGenerated: 0,
  Generated: 1,
})
export const PayStatus = Object.freeze({
  Unpaid: 0,
  Paid: 1,
  Refund: 5,
})
export const AuditDay = Object.freeze({
  OneWorkingDay: 1,
  ThreeWorkingDay: 3,
  FiveWorkingDay: 5,
  TenWorkingDay: 10,
})
export const RefundType = Object.freeze({
  Render: 0,
  IP: 1,
})
export const CouponValidTermList = [
  { value: -1, label: 'deploy_coupon_forever' },
  { value: 1, label: 'deploy_valid_period_1' },
  { value: 3, label: 'deploy_valid_period_3' },
  { value: 6, label: 'deploy_valid_period_6' },
  { value: 12, label: 'deploy_valid_period_12' },
]
export const MemberTermList = [
  { value: 1, label: 'deploy_valid_period_1' },
  { value: 3, label: 'deploy_valid_period_3' },
  { value: 6, label: 'deploy_valid_period_6' },
  { value: 12, label: 'deploy_valid_period_12' },
]
export const SendVoucherList = [
  { value: 1, label: 'common_yes' },
  { value: 0, label: 'common_no' },
]
export const ActivityType = Object.freeze({
  MEMBER: 0,
  COUPON: 1,
  QINYUNCOUPON: 2,
  LOTTERY: 3,
})
export const ActivityTypeList = [
  { value: ActivityType.MEMBER, label: 'deploy_present_member' },
  { value: ActivityType.COUPON, label: 'deploy_present_coupon' },
  { value: ActivityType.QINYUNCOUPON, label: 'deploy_present_qinyun_coupon' },
  { value: ActivityType.LOTTERY, label: 'deploy_present_lottery' },
]
export const ExpireType = Object.freeze({
  VALID: 0,
  EXPIRE: 1,
})

export const ExpireTypeList = [
  { value: ExpireType.VALID, label: 'deploy_expire_date' },
  { value: ExpireType.EXPIRE, label: 'deploy_expire_time' },
]

export const ZoneList = [
  { value: Zone.Domestic, label: 'deploy_domestic' },
  { value: Zone.Foreign, label: 'deploy_overseas' },
]

export const BusinessType = Object.freeze({
  PICTURE: 0,
  ANIMATION: 1,
  ALL: 2,
  DAYAN: 3,
})

export const BusinessFilterList = [
  { value: BusinessType.PICTURE, label: 'common_businessType_0' },
  { value: BusinessType.ANIMATION, label: 'common_businessType_1' },
]

export const DomesticBusinessList = [
  { value: BusinessType.PICTURE, label: 'common_businessType_0' },
  { value: BusinessType.ANIMATION, label: 'common_businessType_1' },
  { value: BusinessType.DAYAN, label: 'common_businessType_3' },
]
export const OverseasBusinessList = [
  { value: BusinessType.ANIMATION, label: 'common_businessType_1' },
]

export const MemberLevel = Object.freeze({
  PICNOTMEMBER: 0,
  PICMEMBER: 1,
  ORDINARY: 49,
  ANIAG: 55,
  ANIAU: 56,
  ANIPT: 57,
  ANIC: 58,
})

export const MemberList = [
  { value: MemberLevel.ORDINARY, label: 'deploy_member_0' },
  { value: MemberLevel.ANIAG, label: 'deploy_member_level_1' },
  { value: MemberLevel.ANIAU, label: 'deploy_member_level_2' },
  { value: MemberLevel.ANIPT, label: 'deploy_member_level_3' },
  { value: MemberLevel.ANIC, label: 'deploy_member_level_4' },
]

export const DomesticMemberList = [
  { value: MemberLevel.ORDINARY, label: 'deploy_member_0' },
  { value: MemberLevel.ANIAU, label: 'deploy_member_level_2' },
  { value: MemberLevel.ANIC, label: 'deploy_member_level_4' },
]

export const PresentMemberList = [
  { value: MemberLevel.ANIAG, label: 'deploy_member_level_1' },
  { value: MemberLevel.ANIAU, label: 'deploy_member_level_2' },
  { value: MemberLevel.ANIPT, label: 'deploy_member_level_3' },
  { value: MemberLevel.ANIC, label: 'deploy_member_level_4' },
]
export const PictureMemberList = [
  { value: MemberLevel.PICNOTMEMBER, label: 'deploy_member_0' },
  { value: MemberLevel.PICMEMBER, label: 'deploy_member_1' },
]

export const CouponList = [
  { value: CouponType.GeneralCoupon, label: 'common_prize_type_3' },
  { value: CouponType.CPUCoupon, label: 'common_prize_type_2' },
  { value: CouponType.GPUCoupon, label: 'common_prize_type_1' },
]

export const QinyunCouponList = [
  { value: CouponType.CPUQingyunCoupon, label: 'common_prize_type_6' },
  { value: CouponType.GPUQingyunCoupon, label: 'common_prize_type_7' },
]
export const PresentType = Object.freeze({
  AMOUNT: 0,
  PROPORTION: 1,
})

export const ActivityStatus = Object.freeze({
  WAIT: 0,
  DOING: 1,
  OFF: 2,
  TOBEACTIVATED: 4,
})
// 增加实名认证类型 0未实名，2审核中，3审核失败，4待审核，5变更中，6个人认证成功，7企业认证成功 8企业认证失败 9个人变更个人失败 10企业变更企业失败 11个人变更企业失败 12个人变更个人变更中 其中9、11归属于6，10归属于7，12归属于5
export const AuthTypeList = Object.freeze({
  UNVERIFIED: 0,
  PersonUnderReview: 1,
  EnterpriseUnderReview: 2,
  PersonalAuthFailed: 3,
  PENDINGREVIEW: 4,
  CHANGING: 5,
  PERSONALVERIFIED: 6,
  ENTERPRISEVERIFIED: 7,
  EnterpriseAuthFail: 8,
  PersonaChangeFailed: 9,
  EnterpriseChangeFailed: 10,
  PersonalToEnterpriseFailed: 11,
  PersonalChanging: 12,
})

export const VerifyStatus = Object.freeze({
  Unverified: 0,
  VERIFIED: 1,
  Fail: 2,
})

export const VerifyStatusList = [
  { value: VerifyStatus.Unverified, label: 'user_recharge_record_verify_status_0' },
  { value: VerifyStatus.VERIFIED, label: 'user_recharge_record_verify_status_1' },
  { value: VerifyStatus.Fail, label: 'user_recharge_record_verify_status_2' },
]

export const RechargeEditType = Object.freeze({
  TransactionId: 0,
  BankFlow: 1,
  FlowRemark: 2,
  AmountCredited: 3,
})

export const RechargeEditTypeList = {
  [RechargeEditType.TransactionId]: {
    ref: 'transactionIdInput',
    status: 'edittingPayRecordId',
    key: 'transactionId',
  },
  [RechargeEditType.BankFlow]: {
    ref: 'bankflowInput',
    status: 'edittingBankPayAmount',
    key: 'bankAmount',
  },
  [RechargeEditType.FlowRemark]: {
    ref: 'remarkInput',
    status: 'edittingRemark',
    key: 'verifyRemark',
  },
  [RechargeEditType.AmountCredited]: {
    ref: 'amountInput',
    status: 'edittingAmount',
    key: 'enterAmount',
  },
}

export const PrizeType = Object.freeze({
  ParticipationPrize: 0,
  FirstPrize: 1,
  SecondPrize: 2,
  ThirdPrize: 3,
  FourthPrize: 4,
  FifthPrize: 5,
  SixthPrize: 6,
  SevenPrize: 7,
})

export const RenderToLeaseStatus = Object.freeze({
  NotTransferred: 0,
  Preparing: 1,
  TransferredIn: 2,
  Closed: 3,
  NotTransferable: 4,
  FailedMirror: 5,
  Transferred: 6,
  FailedTransfer: 7,
  Deleted: 8,
})

export const GiftWay = Object.freeze({
  FirstChargeGift: 1,
  InvitationRegisterGift: 2,
  FifteenPresent: 3,
  OldUsersReturnGift: 4,
  firstAnimationRecharge: 5,
  rechargeAndRedeemGift: 6,
  SystemPresent: 7,
  BindSocialMediaGift: 8,
})

export const FeeWay = Object.freeze({
  Monthly: 0,
  Times: 1,
})

export const GiftAllType = Object.freeze({
  Other: -1,
  Coupon: 0,
  Member: 1,
})

export const ValidTimeType = Object.freeze({
  SEVEN_DAY: 7,
  ONE_MONTH: 30,
  THREE_MONTH: 90,
  HALF_YEAR: 180,
  ONE_YEAR: 365,
})

export const validTimeTypeList = [
  { value: ValidTimeType.SEVEN_DAY, label: 'common_valid_time_type_7' },
  { value: ValidTimeType.ONE_MONTH, label: 'common_valid_time_type_30' },
  { value: ValidTimeType.THREE_MONTH, label: 'common_valid_time_type_90' },
  { value: ValidTimeType.HALF_YEAR, label: 'common_valid_time_type_180' },
  { value: ValidTimeType.ONE_YEAR, label: 'common_valid_time_type_365' },
]

export const CouponActivityType = Object.freeze({
  COMMON: 0,
  EXCHANGE_CODE: 1,
})

export const isDeleteList = [
  { value: '', label: 'common_all' },
  { value: 1, label: 'common_no' },
  { value: 0, label: 'common_yes' },
]
export const Whether = Object.freeze({
  Yes: 1,
  No: 0,
})
